import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadInformationFormComponent } from './lead-information-form.component';
import { CtButtonModule, CtModelModule } from '@ctsolution/ct-framework';
import { CtWebapiModule } from '@ctsolution/ct-webapi';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { LeadInformationFormService } from './lead-information-form.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [LeadInformationFormComponent],
  exports: [LeadInformationFormComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    CtWebapiModule,
    CtModelModule,
    CtButtonModule,
    MatCardModule
  ],
  providers: [LeadInformationFormService]
})
export class LeadInformationFormModule {}
